// extracted by mini-css-extract-plugin
var _1 = "Pill-module__checkIcon--ZbnNr";
var _2 = "Pill-module__container--RQWHs";
var _3 = "Pill-module__disabled--Ax3kg";
var _4 = "Pill-module__selected--q2Jrn";
export { _1 as "checkIcon", _2 as "container", _3 as "disabled", _4 as "selected" }
